module.exports = __webpack_public_path__ + "static/media/9.64605de5.jpg";